<template>

            <li>
                <a :href="$store.state.hrefPrefix + '/columns/' + column.slug">

                    <i v-if="column.blob != null"><img style="width: 116px; height: 116px"  :src="column.blob.url" alt=""/></i>

                    <h2>
                        {{ column.author_languages[0].pivot.name }}
                    </h2>
                </a>
            </li>

</template>

<script>
export default {
    name: "Columns",
    props: {
        column: {
            type: Array,
            default: []
        }
    },

}
</script>

<style>
.Columns-people .Columns-people-list li {
    min-width: 180px;
}
</style>
